import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// Restore token on page load
try {
  const stored = JSON.parse(localStorage.getItem('mecanobenin-auth') || '{}');
  if (stored?.state?.accessToken) {
    api.defaults.headers.common['Authorization'] = `Bearer ${stored.state.accessToken}`;
  }
} catch {}

// Auto-refresh on 401 — si échec → déconnexion forcée
api.interceptors.response.use(
  res => res,
  async error => {
    const original = error.config;

    // Éviter boucle infinie sur les routes d'auth elles-mêmes
    const isAuthRoute = original.url?.includes('/auth/login') ||
                        original.url?.includes('/auth/register') ||
                        original.url?.includes('/auth/refresh');

    if (error.response?.status === 401 && !original._retry && !isAuthRoute) {
      original._retry = true;
      try {
        const { useAuthStore } = await import('../store/authStore');
        const refreshed = await useAuthStore.getState().refreshAccessToken();
        if (refreshed) {
          original.headers['Authorization'] = api.defaults.headers.common['Authorization'];
          return api(original);
        } else {
          // Refresh échoué → déconnexion forcée
          await useAuthStore.getState().forceLogout();
        }
      } catch {
        const { useAuthStore } = await import('../store/authStore');
        await useAuthStore.getState().forceLogout();
      }
    }
    return Promise.reject(error);
  }
);

export const prestataireService = {
  getAll: (params) => api.get('/prestataires', { params }),
  getOne: (id) => api.get(`/prestataires/${id}`),
  updateProfile: (data) => api.put('/prestataires/profile', data),
  toggleAvailability: () => api.patch('/prestataires/availability'),
  getStats: () => api.get('/prestataires/dashboard/stats'),
  uploadProfilePhoto: (file) => {
    const fd = new FormData(); fd.append('photo', file);
    return api.post('/prestataires/photo/profile', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  addPhoto: (file, caption) => {
    const fd = new FormData(); fd.append('photo', file);
    if (caption) fd.append('caption', caption);
    return api.post('/prestataires/photo/realisation', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  deletePhoto: (photoId) => api.delete(`/prestataires/photo/${photoId}`),
};

export const authService = {
  registerClient: (data) => api.post('/auth/register/client', data),
  registerPrestataire: (data) => api.post('/auth/register/prestataire', data),
  getMe: () => api.get('/auth/me'),
};

export const reviewService = {
  add: (prestataireId, data) => api.post(`/reviews/${prestataireId}`, data),
  getAll: (prestataireId) => api.get(`/reviews/${prestataireId}`),
};

export const messageService = {
  send: (receiverId, content) => api.post('/messages', { receiverId, content }),
  getConversations: () => api.get('/messages/conversations'),
  getThread: (userId) => api.get(`/messages/thread/${userId}`),
};

export const bookingService = {
  create: (data) => api.post('/bookings', data),
  getMy: () => api.get('/bookings/my'),
  updateStatus: (id, status) => api.patch(`/bookings/${id}/status`, { status }),
};

export const paymentService = {
  createIntent: (data) => api.post('/payments/create-intent', data),
};

export default api;
